import React, { useState, useEffect, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMapMarkerAlt, faBoxOpen, faPrint, faEye, faPhoneVolume,
    faHandHoldingUsd, faThumbsUp, faHandHoldingMedical, faCoins, faUsers, faPlus, faMinus,
    faFileSignature, faFileAlt, faFileInvoice, faTruck, faCheck, faTimes, faTruckLoading,
    faArrowLeft
} from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import moment from 'moment';
import { ThemeContext } from '../Common/ThemeProvider';
import Alert from 'react-s-alert';
import VehicleChart from '../Common/VehicleChart';
import { FetchActivatedUsers } from '../Common/Services/UserService';
import Select from 'react-select';
import PickNTrackPattern from '../../Images/Dashboard_theme.jpg';

const AdminDashBoard = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [Enquiry, setEnquiry] = useState([]);
    const [Survey, setSurvey] = useState([]);
    const [SelectedSurvey, setSelectedSurvey] = useState({});
    const [SelectedGoods, setSelectedGoods] = useState([]);
    const [displaySurveyView, setdisplaySurveyView] = useState("none");
    const [displayGoodsView, setdisplayGoodsView] = useState("none");
    const [TotalCFT, setTotalCFT] = useState(0);
    const [VehicleRequired, setVehicleRequired] = useState("NA");
    const [ActivityOption, setActivityOption] = useState(0);
    const [BorrowRequest, setBorrowRequest] = useState([]);
    const [Leads, setLeads] = useState([]);
    const [Quotes, setQuotes] = useState([]);
    const [Dlvrs, setDlvrs] = useState([]);
    const [PartnerUsers, setPartnerUsers] = useState([]);
    const [SelectedLeads, setSelectedLeads] = useState({});
    const [SelectedQuotes, setSelectedQuotes] = useState({});
    const [SelectedDlvrs, setSelectedDlvrs] = useState({});
    const [IntServLeadFlag, setIntServLeadFlag] = useState(0);
    const [IntServQuoteFlag, setIntServQuoteFlag] = useState(0);
    const [IntServDlvrFlag, setIntServDlvrFlag] = useState(0);
    const [LogoImage, setLogoImage] = useState(null);
    const [ShowLogs, setShowLogs] = useState(false);
    const [DlvrAdditionalInfo, setDlvrAdditionalInfo] = useState(false);
    const [SelectedPartner, setSelectedPartner] = useState({ value: null, label: null });


    useEffect(() => {
        FetchEnquiry();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchEnquiry = () => {
        Axiosfetch(baseURL + "GetEnquiriesByStatus", "POST", { Status: 1 }, EnquiryDataSuccess, Failure);
    };

    const EnquiryDataSuccess = (data) => {
        if (data.length > 0) {
            setEnquiry(data);
        }
        else {
            setEnquiry([]);
        }

        FetchSurvey();
    };

    const FetchSurvey = () => {
        Axiosfetch(baseURL + "GetCustomersByDate", "POST", {
            Date: moment().utc()
        }, SurveyDataSuccess, Failure);
    };

    const SurveyDataSuccess = (data) => {
        if (data.length > 0) {
            setSurvey(data);
        }
        else {
            setSurvey([]);
        }
    };

    const hideSurveyView = () => {
        setdisplaySurveyView("none");
    };

    const hideGoodsView = () => {
        setdisplayGoodsView("none");
    };

    const onSurveyView = (SurveyID) => {
        let surveyData = Survey.filter(s => s._id === SurveyID);
        if (surveyData.length > 0) {
            setSelectedSurvey(surveyData[0]);
            setdisplaySurveyView("block");
        }
        else {
            setSelectedSurvey({});
            setdisplaySurveyView("none");
        }
    };

    const onGoodsView = (SurveyID) => {
        let surveyData = Survey.filter(s => s._id === SurveyID);
        if (surveyData.length > 0 && surveyData[0].Goods.length > 0) {

            var cftValue = 0;
            surveyData[0].Goods.forEach(survey => {
                cftValue += (survey.CFTValue * survey.Quantity)
            });

            let vehcileData = VehicleChart.filter(v => v.MinCFT <= cftValue && v.MaxCFT >= cftValue);
            setVehicleRequired(vehcileData.length > 0 ? vehcileData[0].TypeOfLoad : "NA");

            setSelectedGoods(surveyData[0].Goods);
            setTotalCFT(cftValue);
            setdisplayGoodsView("block");
        }
        else {
            setSelectedGoods([]);
            setTotalCFT(0);
        }
    };

    const OnEnquiryClick = () => {
        setActivityOption(0);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
    };


    const OnBorrowClick = () => {
        setActivityOption(2);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
        if (BorrowRequest.length === 0) {
            GetBorrowRequests();
        }
    };

    const GetBorrowRequests = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        Axiosfetch(baseURL + "GetBorrowRequestByRequestToID", "POST", { RequestTo: userData._id }, BorrowSuccess, Failure);
    };

    const BorrowSuccess = (data) => {
        if (data.length > 0) {
            setBorrowRequest(data);
        }
        else {
            setBorrowRequest([]);
        }
    };

    const OnBorrowApprove = (borrowID) => {
        Axiosfetch(baseURL + "ApproveBorrowRequest", "POST", { _id: borrowID }, BorrowUpdateSuccess, Failure);
    };

    const BorrowUpdateSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            setActivityOption(2);
            GetBorrowRequests();
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnLeadsClick = () => {
        setActivityOption(3);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
        setSelectedPartner({ value: null, label: null });
        FetchActivatedUsers(null, UserSuccess, Failure);
    };

    const OnQuotesClick = () => {
        setActivityOption(4);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
        setSelectedPartner({ value: null, label: null });
        if (PartnerUsers && PartnerUsers.length === 0) {
            FetchActivatedUsers(null, UserSuccess, Failure);
        }
    };

    const OnDlvrsClick = () => {
        setActivityOption(5);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
        setSelectedPartner({ value: null, label: null });
        if (PartnerUsers && PartnerUsers.length === 0) {
            FetchActivatedUsers(null, UserSuccess, Failure);
        }
    };

    const UserSuccess = (data) => {
        if (data && data.length > 0) {
            let userlist = [];
            data.forEach(user => {
                if (user.Organization.length > 0 && ((user.ExpiryDate === undefined || user.ExpiryDate === null) ||
                    (user.ExpiryDate !== "" && moment() < moment(user.ExpiryDate)))) {
                    userlist.push({ value: user.Organization[0]._id, label: user.FirstName + " " + user.LastName + " [" + user.Organization[0].Name + "]" });
                }
            });

            setPartnerUsers(userlist);
        }
        else {
            setPartnerUsers([]);
        }
    };

    const OnPartnerClick = (partner) => {
        let orgID = partner ? partner.value : null;

        if (partner !== null) {
            setSelectedPartner(partner);
        }
        else {
            setSelectedPartner({ value: null, label: null });
        }

        if (orgID) {
            if (ActivityOption === 3) {
                Axiosfetch(baseURL + "GetIntServLeadsByOrgID", "POST",
                    { OrgID: orgID }, LeadsSuccess, Failure);
            }
            if (ActivityOption === 5) {
                Axiosfetch(baseURL + "GetAdminIntServDlvrByOrgID", "POST",
                    { OrgID: orgID }, DlvrsSuccess, Failure);
            }
            else {
                Axiosfetch(baseURL + "GetIntServQuotesByOrgID", "POST",
                    { OrgID: orgID }, QuotesSuccess, Failure);
            }
        }
        else {
            setLeads([]);
            setQuotes([]);
        }
    };

    const LeadsSuccess = (data) => {
        if (data.length > 0) {
            setLeads(data);
        }
        else {
            setLeads([]);
        }
    };

    const QuotesSuccess = (data) => {
        if (data.length > 0) {
            setQuotes(data);
        }
        else {
            setQuotes([]);
        }
    };

    const DlvrsSuccess = (data) => {
        if (data.length > 0) {
            setDlvrs(data);
        }
        else {
            setDlvrs([]);
        }
    };

    const OnLeadSummary = (id) => {
        let leadDetails = Leads.filter(l => l._id === id);
        if (leadDetails.length > 0) {
            setSelectedLeads(leadDetails[0]);
            setIntServLeadFlag(1);
            setIntServQuoteFlag(0);
            setIntServDlvrFlag(0);
            if (leadDetails[0].Partner && leadDetails[0].Partner.length > 0 && leadDetails[0].Partner[0].Logo !== "") {
                GetOrganizationLogo(leadDetails[0].Organization[0].Logo);
            }
        }
    };

    const onShowAdditionalInfo = () => {
        setDlvrAdditionalInfo(!DlvrAdditionalInfo);
    }

    const OnQuoteSummary = (id) => {
        let quoteDetails = Quotes.filter(l => l._id === id);
        if (quoteDetails.length > 0) {
            setSelectedQuotes(quoteDetails[0]);
            setIntServLeadFlag(0);
            setIntServQuoteFlag(1);
            setIntServDlvrFlag(0);
            if (quoteDetails[0].Partner && quoteDetails[0].Partner.length > 0 && quoteDetails[0].Partner[0].Logo !== "") {
                GetOrganizationLogo(quoteDetails[0].Organization[0].Logo);
            }
        }
    };

    const OnDlvrSummary = (id) => {
        let dlvrDetails = Dlvrs.filter(l => l._id === id);
        if (dlvrDetails.length > 0) {
            setSelectedDlvrs(dlvrDetails[0]);
            setIntServLeadFlag(0);
            setIntServQuoteFlag(0);
            setIntServDlvrFlag(1);
            if (dlvrDetails[0].DestOrganization && dlvrDetails[0].DestOrganization.length > 0 &&
                dlvrDetails[0].DestOrganization[0].Logo !== "") {
                GetOrganizationLogo(dlvrDetails[0].Organization[0].Logo);
            }
        }
    };

    const GetOrganizationLogo = (logo) => {
        let file = logo;
        if (file !== null) {
            Axiosfetch(baseURL + "GetOrganizationLogo", "POST", { fileName: file }, LogoSuccess, Failure);
        }
    };

    const LogoSuccess = (data) => {
        if (data.success) {
            setLogoImage(data.fileData);
        }
        else {
            setLogoImage(null);
        }
    };

    const GetLogsStatusName = (status) => {
        switch (status) {
            case 1: return "Accept";
            case 2: return "In Progress";
            case 3: return "Booked";
            case 4: return "Completed";
            default: return "";
        };
    };

    const onShowLogs = () => {
        setShowLogs(!ShowLogs);
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme cd-background sidemenu-show" style={{
                marginBottom: "0.8rem",
                backgroundRepeat: "round", backgroundSize: "contain", backgroundImage: `url('${PickNTrackPattern}')`
            }}>
                <div className="row" style={{ marginLeft: "0.2rem" }}>
                    <div className="col-md-4 border-right-style" style={{ backgroundColor: "rgba(255,255,255,0.8)" }}>
                        <div style={{ textAlign: "center", fontSize: "1.2rem", padding: "5px" }}>
                            <div className='pb-1' style={{ display: "flex", justifyContent: "space-evenly" }}>
                                <span className="cursor onhover" style={{ color: (ActivityOption === 0 ? "green" : "black") }} data-tip="Enquiry" onClick={OnEnquiryClick}><FontAwesomeIcon icon={faPrint} /></span>
                                <span className="cursor onhover" data-tip="Purchase Request" onClick={OnBorrowClick}><FontAwesomeIcon icon={faHandHoldingUsd} /></span>
                                <span className="cursor onhover" style={{ color: (ActivityOption === 3 ? "green" : "black") }} data-tip="Leads Enquiry" onClick={OnLeadsClick}><FontAwesomeIcon icon={faUsers} /></span>
                                <span className="cursor onhover" style={{ color: (ActivityOption === 4 ? "green" : "black") }} data-tip="Quotes Enquiry" onClick={OnQuotesClick}><FontAwesomeIcon icon={faFileSignature} /></span>
                                <span className="cursor onhover" style={{ color: (ActivityOption === 5 ? "green" : "black") }} data-tip="Delivery Enquiry" onClick={OnDlvrsClick}><FontAwesomeIcon icon={faTruck} /></span>
                            </div>
                        </div>
                        {ActivityOption === 0 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "70vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div style={{ textAlign: "center", fontSize: "1.2rem" }}>{ActivityOption === 0 ? "Enquiry" : (ActivityOption === 2 ? "Purchase" : (ActivityOption === 3 ? "Leads" : (ActivityOption === 4 ? "Quotes" : "Delivery")))}</div>
                            {Enquiry.length > 0 && Enquiry.map(enquiry => (
                                <div title={(enquiry.SurveyRequired === 1 ? "Survey Required" : "")} className="EnquiryList" key={enquiry._id} style={{
                                    backgroundColor: "white", borderLeft: (enquiry.SurveyRequired === 1 ? "5px solid green" : "5px solid red")
                                }}>
                                    <div className='mb-2' style={{ fontSize: "1rem" }}>{enquiry.Subject} - {enquiry.MoveType}</div>
                                    {enquiry.User.length > 0 && (<div style={{ border: "1px solid #ccc", padding: "2px", borderRadius: "6px" }}>
                                        <span style={{ paddingRight: "10px" }}><FontAwesomeIcon icon={faPhoneVolume} /></span>
                                        {enquiry.User.length > 0 && enquiry.User[0].FirstName + " " + enquiry.User[0].LastName + " - " + enquiry.User[0].PhoneNumber}</div>)}
                                    <div style={{ padding: "2px 0" }}><span> <FontAwesomeIcon icon={faMapMarkerAlt} /></span> <span> {enquiry.City + ", " + enquiry.State + ", " + enquiry.Country}</span></div>
                                    <div style={{ color: "#005582" }}>Created On : {moment(enquiry.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                </div>
                            ))}
                            {Enquiry.length === 0 && (<div className="NoItemStyle">No Pending Enquiry</div>)}
                        </div>)}
                        {ActivityOption === 2 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "72vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div style={{ textAlign: "center", fontSize: "1.2rem" }}>{ActivityOption === 0 ? "Enquiry" : (ActivityOption === 2 ? "Purchase" : (ActivityOption === 3 ? "Leads" : (ActivityOption === 4 ? "Quotes" : "Delivery")))}</div>
                            {BorrowRequest.length > 0 && BorrowRequest.map(borrow => (
                                <div className="EnquiryList" key={borrow._id} style={{ backgroundColor: "white" }}>
                                    <div style={{ padding: "3px", borderRadius: "6px" }}>
                                        <span>{(borrow.RequestTo ? `By : ${borrow.RequestTo[0].FirstName} ${borrow.RequestTo[0].LastName}` : "")}</span>
                                        <span className="cursor" title="Approve" style={{ float: "right", paddingRight: "5px" }} onClick={() => OnBorrowApprove(borrow._id)}>
                                            <FontAwesomeIcon style={{ color: "green" }} icon={faThumbsUp} /></span>
                                    </div>
                                    <div style={{ fontSize: "2rem", display: "flex", justifyContent: "center" }}>
                                        <div style={{ paddingRight: "20px", margin: "auto 0", fontSize: "1.2rem" }} title={(borrow.RequestType === 1 ? "Purchase" : "Request")}>
                                            <FontAwesomeIcon style={{ color: (borrow.RequestType !== 1 ? "orange" : "black") }} icon={borrow.RequestType === 1 ? faHandHoldingMedical : faCoins} />
                                        </div>
                                        <div>{borrow.Points}</div>
                                    </div>
                                    <div title={borrow.Remarks} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><b>Remarks</b> : {borrow.Remarks}</div>
                                    <div style={{ color: "gray" }}>Created On : {moment(borrow.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                </div>
                            ))}
                            {BorrowRequest.length === 0 && (<div className="NoItemStyle">No Pending Borrow Request</div>)}
                        </div>)}
                        {(ActivityOption === 3 || ActivityOption === 4 || ActivityOption === 5) && (<div>
                            <div style={{ textAlign: "center", fontSize: "1.2rem" }}>{ActivityOption === 0 ? "Enquiry" : (ActivityOption === 2 ? "Purchase" : (ActivityOption === 3 ? "Leads" : (ActivityOption === 4 ? "Quotes" : "Delivery")))}</div>
                            <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true}
                                value={(SelectedPartner.value ? SelectedPartner : '')} placeholder="Select Partner"
                                options={PartnerUsers} onChange={OnPartnerClick}></Select>
                        </div>)}
                        {ActivityOption === 3 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "60vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div>
                                {Leads.length > 0 && Leads.map(lead => (
                                    <div className="EnquiryList cursor" key={lead._id}
                                        style={{ backgroundColor: "white", position: "relative", border: ((SelectedLeads && SelectedLeads._id && SelectedLeads._id === lead._id) ? "2px solid #00b300" : "1px solid #ccc") }}>
                                        <FontAwesomeIcon className={`${CurrentTheme}Color`} style={{
                                            paddingRight: "10px", left: "10px",
                                            position: "absolute", fontSize: "2rem"
                                        }} icon={faFileAlt}></FontAwesomeIcon>
                                        <div onClick={() => OnLeadSummary(lead._id)}>
                                            {lead.Organization && lead.Organization.length > 0 &&
                                                (<span style={{ fontSize: "1rem" }}>{lead.Organization[0].Name}</span>)}
                                            <div title={lead.Remarks} style={{ overflow: "hidden", padding: "5px", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><b>Remarks</b> : {lead.Remarks}</div>
                                            <div style={{ color: "gray", fontSize: "13px" }}>Created Date : {moment(lead.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                        </div>
                                    </div>
                                ))}
                                {Leads.length === 0 && (<div className="NoItemStyle m-2">No Leads Available.</div>)}
                            </div>
                        </div>)}
                        {ActivityOption === 4 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "60vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div>
                                {Quotes.length > 0 && Quotes.map(quote => (
                                    <div className="EnquiryList cursor" key={quote._id}
                                        style={{ backgroundColor: "white", position: "relative", border: ((SelectedQuotes && SelectedQuotes._id && SelectedQuotes._id === quote._id) ? "2px solid #00b300" : "1px solid #ccc") }}>
                                        <FontAwesomeIcon className={`${CurrentTheme}Color`} style={{ paddingRight: "10px", left: "10px", position: "absolute", fontSize: "2rem" }} icon={faFileInvoice}></FontAwesomeIcon>
                                        <div onClick={() => OnQuoteSummary(quote._id)}>
                                            {quote.Organization && quote.Organization.length > 0 &&
                                                (<div className='mb-2' style={{ fontSize: "1rem" }}>{quote.Organization[0].Name}</div>)}
                                            <div style={{ overflow: "hidden", margin: "5px 0", fontWeight: "bold", backgroundColor: "#eee", borderRadius: "10px", color: "#005582", textTransform: "uppercase", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{`${quote.Source} - ${quote.Dest}`}</div>
                                            <div style={{ fontSize: "1.2rem", overflow: "hidden", padding: "5px", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{`Total CFT : ${quote.CFT}`}</div>
                                            <div style={{ color: "gray", fontSize: "13px" }}>Created On : {moment(quote.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                        </div>
                                    </div>
                                ))}
                                {Quotes.length === 0 && (<div className="NoItemStyle m-2">No Quotes Available</div>)}
                            </div>
                        </div>)}
                        {ActivityOption === 5 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "60vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div>
                                {Dlvrs.length > 0 && Dlvrs.map(delivery => (
                                    <div className="EnquiryList cursor" key={delivery._id}
                                        style={{ backgroundColor: "white", position: "relative", border: ((SelectedDlvrs && SelectedDlvrs._id && SelectedDlvrs._id === delivery._id) ? "2px solid #00b300" : "1px solid #ccc") }}>
                                        <FontAwesomeIcon className={`${CurrentTheme}Color`} style={{ paddingRight: "10px", left: "10px", position: "absolute", fontSize: "1.6rem" }} icon={faTruckLoading}></FontAwesomeIcon>
                                        <div onClick={() => OnDlvrSummary(delivery._id)}>
                                            {delivery.Organization && delivery.Organization.length > 0 &&
                                                (<div className='mb-2' style={{ fontSize: "1rem" }}>{delivery.Organization[0].Name}</div>)}
                                            <div style={{ fontSize: "1rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{`Total CFT : ${delivery.TotalCFT}`}</div>
                                            <div style={{ overflow: "hidden", fontWeight: "bold", backgroundColor: "#eee", borderRadius: "10px", color: "#005582", textTransform: "uppercase", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{`${delivery.OriginCity} - ${delivery.DestCity}`}</div>
                                            {delivery.DestOrganization && delivery.DestOrganization.length > 0 && (<span>To : {delivery.DestOrganization[0].Name}</span>)}
                                            <div style={{ color: "gray", fontSize: "13px" }}>Created On : {moment(delivery.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                        </div>
                                    </div>
                                ))}
                                {Dlvrs.length === 0 && (<div className="NoItemStyle m-2">No Deliveries Available</div>)}
                            </div>
                        </div>)}
                    </div>
                    {IntServLeadFlag !== 1 && IntServQuoteFlag !== 1 && IntServDlvrFlag !== 1 && (<div className="col-md-8">
                        <div className="row" style={{ justifyContent: "space-evenly" }}>
                            <div style={{ height: "71px", margin: "10px 0 10px 10px" }} className="col-md-5 cd-cards2 cd-cardboundry align-center">
                                <div className="row">
                                    <div className="col-md-4 col-4" style={{ fontSize: "30px" }}>
                                        <FontAwesomeIcon icon={faPrint} />
                                    </div>
                                    <div className="col-md-8 col-8">
                                        <span style={{ fontSize: "15px" }}>Active Enquiry</span>
                                        <div style={{ fontSize: "18px" }}>
                                            <span style={{ verticalAlign: "top", paddingLeft: "4px" }}>{Enquiry.length}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="offset-md-1 col-md-5 cd-cards2 cd-cardboundry align-center" style={{ height: "71px", margin: "10px 0 10px 10px" }}>
                                <div className="row">
                                    <div className="col-md-4 col-4" style={{ fontSize: "30px" }}>
                                        <FontAwesomeIcon icon={faBoxOpen} />
                                    </div>
                                    <div className="col-md-8 col-8">
                                        <span style={{ fontSize: "15px" }}>Active Survey</span>
                                        <div style={{ fontSize: "18px" }}>
                                            <span style={{ verticalAlign: "top", paddingLeft: "4px" }}>{Survey.length}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: "20px" }}>
                            <div className="col-md-12">
                                <div style={{ height: "60vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                                    <table className="table table-striped align-center">
                                        <thead>
                                            <tr>
                                                <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Survey No.</th>
                                                <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Delivery Date</th>
                                                <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Survey.length > 0 && Survey.map(survey => (
                                                <tr key={survey._id}>
                                                    <td>{survey.SurveyID + "-" + moment(survey.createdAt).local().format("DDMMYYYY")}</td>
                                                    <td>{moment(survey.PreferredDeliveryDate).local().format("DD/MM/YYYY")}</td>
                                                    <td><div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                                        <span onClick={() => onSurveyView(survey._id)} className="cursor" title="View Survey"><FontAwesomeIcon icon={faEye} /></span>
                                                        <span onClick={() => onGoodsView(survey._id)} className="cursor" title="View Goods"><FontAwesomeIcon icon={faBoxOpen} /></span>
                                                    </div></td>
                                                </tr>
                                            ))}
                                            {Survey.length === 0 && (<tr><td colSpan="3"><div>No Pending Survey</div></td></tr>)}
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>)}
                    {IntServLeadFlag === 1 && (<div className="col-md-8" style={{ height: "80vh", overflow: "auto" }}>
                        <div className="row">
                            <div className="col-md-12">
                                {SelectedLeads._id !== undefined && (
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <div className="card-title p-2">
                                                <div className="card-text p-1">
                                                    <div className="sourceDest-style" style={{ margin: "0" }}>
                                                        <h5>{SelectedLeads.CustSource}</h5>
                                                        <h5>{SelectedLeads.CustDest}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ paddingTop: "5px" }}>
                                                <ul className="progressbar">
                                                    <li className={SelectedLeads && SelectedLeads.LeadLogs && SelectedLeads.LeadLogs.length > 0 ? "active" : ""}>
                                                        Accept
                                                    </li>
                                                    <li className={SelectedLeads && SelectedLeads.LeadLogs && SelectedLeads.LeadLogs.length > 1 ? "active" : ""}>
                                                        In Progress
                                                    </li>
                                                    <li className={SelectedLeads && SelectedLeads.LeadLogs && SelectedLeads.LeadLogs.length > 2 ? "active" : ""}>
                                                        Booked
                                                    </li>
                                                    <li className={SelectedLeads && SelectedLeads.LeadLogs && SelectedLeads.LeadLogs.length > 3 ? "active" : ""}>
                                                        Complete
                                                    </li>
                                                </ul>
                                            </div>
                                            {SelectedLeads.LeadLogs && (<div className="m-3">
                                                <table className="table table-striped table-bordered">
                                                    <tbody>
                                                        {SelectedLeads.LeadLogs.map((logs, index) => (
                                                            <tr className="border-bottom" key={logs + "_" + index}>
                                                                <td>
                                                                    <div style={{ padding: "0 20px" }} className="align-center">{index + 1}</div>
                                                                </td>
                                                                <td>
                                                                    <div className="align-left">{GetLogsStatusName(logs.Status)}</div></td>
                                                                <td>
                                                                    <div className="align-center">{moment(logs.CreatedDate).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>)}

                                            {(SelectedLeads && SelectedLeads.LeadLogs &&
                                                SelectedLeads.LeadLogs.length > 0) && (<div style={{ marginBottom: "40px" }}>
                                                    <div onClick={onShowLogs} className="Logs-show-style">Details
                                                        <span className="cursor hover-style" title="Hide / Show Logs" style={{ paddingRight: "20px", float: "right" }}>
                                                            <FontAwesomeIcon icon={!ShowLogs ? faPlus : faMinus} /></span></div>
                                                    {ShowLogs && (<div>
                                                        <div className="p-3 align-center">
                                                            <h6><i>"{SelectedLeads.Remarks}"</i></h6>
                                                        </div>
                                                        <div className="row" style={{ margin: "0 10px" }}>
                                                            <div className="col-md-7 col-12" style={{ display: "flex", paddingLeft: "1rem", alignItems: "center" }}>
                                                                <div>
                                                                    {LogoImage && (
                                                                        <img className="companylogoStyle" alt="Org Logo" width="120" height="120" src={LogoImage}></img>)}
                                                                </div>
                                                                {SelectedLeads.Organization && SelectedLeads.Organization.length > 0 &&
                                                                    (<div className="p-2" style={{ flex: "2" }}>
                                                                        <h5>MFI {SelectedLeads.Organization[0].City}</h5>
                                                                        <i><h6>{SelectedLeads.Organization[0].Name}</h6></i>
                                                                        <i><h6>Ph No. : {SelectedLeads.Organization[0].Contact}</h6></i>
                                                                    </div>)}
                                                            </div>
                                                            <div className="col-md-5 col-12 p-2 border" style={{ textAlign: "center", paddingLeft: "5px", borderRadius: "10px" }}>
                                                                <h5 className="p-1" style={{ borderBottom: "1px solid #ccc" }}>Customer Details</h5>
                                                                <div>{SelectedLeads.CustName}</div>
                                                                <i><div>Ph No. : {SelectedLeads.CustContact}</div></i>
                                                                {SelectedLeads.CustEmail !== "" && (<i><div>Email : {SelectedLeads.CustEmail}</div></i>)}

                                                            </div>
                                                        </div>
                                                    </div>)}
                                                </div>)}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>)}
                    {IntServQuoteFlag === 1 && (<div className="col-md-8" style={{ height: "80vh", overflow: "auto" }}>
                        <div className="row">
                            <div className="col-md-12 col-12">
                                {SelectedQuotes._id !== undefined && (
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <div style={{ display: "flex", justifyContent: "space-between" }} className="card-title p-2 border-bottom">
                                                <h4 style={{ paddingLeft: "1rem" }}>Summary</h4>
                                            </div>
                                            <div className="card-text p-1">
                                                <div className="row" style={{ margin: "0 10px" }}>
                                                    <div className="col-md-9 col-12" style={{ display: "flex", paddingLeft: "1rem", alignItems: "center" }}>
                                                        <div>
                                                            {LogoImage && (
                                                                <img className="companylogoStyle" alt="Org Logo" width="120" height="120" src={LogoImage}></img>)}
                                                        </div>
                                                        {SelectedQuotes.Organization && SelectedQuotes.Organization.length > 0 &&
                                                            (<div className="p-2" style={{ flex: "2" }}>
                                                                <h5>MFI {SelectedQuotes.Organization[0].City}</h5>
                                                                <i><h6>{SelectedQuotes.Organization[0].Name}</h6></i>
                                                                <i><h6>Ph No. : {SelectedQuotes.Organization[0].Contact}</h6></i>
                                                            </div>)}
                                                    </div>
                                                    <div className="col-md-3 col-12 p-2" style={{ textAlign: "center", paddingLeft: "5px" }}>
                                                        <h5 className={`p-1 ${CurrentTheme}`} style={{ color: "white", borderRadius: "10px" }}>CFT - {SelectedQuotes.CFT}</h5>
                                                    </div>
                                                </div>
                                                <div className="p-3 align-center">
                                                    <h6 title={SelectedQuotes.Remarks} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><i>"{SelectedQuotes.Remarks}"</i></h6>
                                                </div>
                                                <div className="sourceDest-style">
                                                    <h5>{SelectedQuotes.Source}</h5>
                                                    <h5>{SelectedQuotes.Dest}</h5>
                                                </div>
                                            </div>
                                            {(SelectedQuotes && SelectedQuotes.QuoteLogs &&
                                                SelectedQuotes.QuoteLogs.length > 0) && (<div style={{ marginBottom: "40px" }}>
                                                    <div onClick={onShowLogs} className="Logs-show-style">Logs
                                                        <span className="cursor hover-style" title="Hide / Show Logs" style={{ paddingRight: "20px", float: "right" }}><FontAwesomeIcon icon={!ShowLogs ? faPlus : faMinus} /></span></div>
                                                    {ShowLogs && (<div className="m-3" style={{ overflow: "auto" }}>
                                                        <table className="table table-striped table-bordered align-center">
                                                            <thead>
                                                                <tr>
                                                                    <th>SI No.</th>
                                                                    <th>Amount</th>
                                                                    <th style={{ width: "40%" }}>Remarks</th>
                                                                    <th>Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {SelectedQuotes.QuoteLogs.map((logs, index) => (
                                                                    <tr style={{ color: (logs.Amount === 0 ? "red" : "") }} className="border-bottom" key={logs + "_" + index}>
                                                                        <td>
                                                                            <div style={{ padding: "0 20px" }} className="align-center">{index + 1}</div>
                                                                        </td>
                                                                        <td>
                                                                            <div>{logs.Amount}</div>
                                                                        </td>
                                                                        <td style={{ display: "flex", justifyContent: "center" }}>
                                                                            <div title={logs.Remarks} style={{
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis", whiteSpace: "nowrap", width: "250px"
                                                                            }}>{logs.Remarks}</div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="align-center">{moment(logs.CreatedDate).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>)}
                                                </div>)}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>)}
                    {IntServDlvrFlag === 1 && (<div className="col-md-8" style={{ height: "80vh", overflow: "auto" }}>
                        <div className="row">
                            <div className="col-md-12 col-12">
                                {SelectedDlvrs._id !== undefined && (
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <div style={{ display: "flex", justifyContent: "space-between" }} className="card-title p-2 border-bottom">
                                                <h4 style={{ paddingLeft: "1rem" }}>Summary</h4>
                                            </div>
                                            <div className="card-text p-1">
                                                <div className="row" style={{ margin: "0 10px 5px 10px" }}>
                                                    <div className="col-md-9 col-12" style={{ display: "flex", paddingLeft: "1rem", alignItems: "center" }}>
                                                        <div>
                                                            {LogoImage && (
                                                                <img className="companylogoStyle" alt="Org Logo" width="120" height="120" src={LogoImage}></img>)}
                                                        </div>
                                                        {SelectedDlvrs.Organization && SelectedDlvrs.Organization.length > 0 &&
                                                            (<div className="p-2" style={{ flex: "2" }}>
                                                                <h5>MFI {SelectedDlvrs.Organization[0].City}</h5>
                                                                <i><h6>{SelectedDlvrs.Organization[0].Name}</h6></i>
                                                                <i><h6>Ph No. : {SelectedDlvrs.Organization[0].Contact}</h6></i>
                                                            </div>)}
                                                    </div>
                                                    <div className="col-md-3 col-12 p-2" style={{ textAlign: "center", paddingLeft: "5px" }}>
                                                        <h5 className="p-1" style={{ backgroundColor: "rgb(51, 153, 255)", color: "white", borderRadius: "10px" }}>
                                                            <span>CFT - {SelectedDlvrs.TotalCFT}
                                                            </span></h5>
                                                        <h6>
                                                            <div><u>Job ID</u></div>
                                                            <div style={{ fontWeight: "600" }}>
                                                                {`${SelectedDlvrs.JobID}_${moment(SelectedDlvrs.createdAt).local().format("DDMMYYYY")}`}
                                                            </div>
                                                        </h6>
                                                    </div>
                                                </div>
                                                {SelectedDlvrs && (<div className='row p-0 m-0 text-center d-flex justify-content-center'>
                                                    <div className='col-md-2 DlvrHighlight m-1'>Packages : <span >{SelectedDlvrs.TotalPackages}</span></div>
                                                    <div className='col-md-2 DlvrHighlight m-1'>HMS : <span style={{ color: (SelectedDlvrs.HardmenRequired === 1 ? "green" : "red") }}>
                                                        <FontAwesomeIcon icon={(SelectedDlvrs.HardmenRequired === 1 ? faCheck : faTimes)}></FontAwesomeIcon></span></div>
                                                    <div className='col-md-3 DlvrHighlight m-1'>Local Settling : <span style={{ color: (SelectedDlvrs.LocalSettling === 1 ? "green" : "red") }}>
                                                        <FontAwesomeIcon icon={(SelectedDlvrs.LocalSettling === 1 ? faCheck : faTimes)}></FontAwesomeIcon></span></div>
                                                    <div className='col-md-2 DlvrHighlight m-1'>WareHouse : <span style={{ color: (SelectedDlvrs.WareHouseRequired === 1 ? "green" : "red") }}>
                                                        <FontAwesomeIcon icon={(SelectedDlvrs.WareHouseRequired === 1 ? faCheck : faTimes)}></FontAwesomeIcon></span></div>
                                                    <div className='col-md-2 DlvrHighlight m-1'>Floors : <span >{SelectedDlvrs.FloorNumber === 0 ? "Ground" : SelectedDlvrs.FloorNumber}</span></div>
                                                    <div className='col-md-2 DlvrHighlight m-1'>Lift : <span style={{ color: (SelectedDlvrs.LiftAvailable === 1 ? "green" : "red") }}>
                                                        <FontAwesomeIcon icon={(SelectedDlvrs.LiftAvailable === 1 ? faCheck : faTimes)}></FontAwesomeIcon></span></div>
                                                    <div className='col-md-2 DlvrHighlight m-1'>Man Power : <span>{SelectedDlvrs.TotalManPower}</span></div>
                                                </div>)}
                                                <div className="p-3 align-center">
                                                    <h6 title={SelectedDlvrs.Remarks} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><i>"{SelectedDlvrs.Remarks}"</i></h6>
                                                </div>
                                                <div className="sourceDest-style">
                                                    <h5>{SelectedDlvrs.OriginCity}</h5>
                                                    <h5>{SelectedDlvrs.DestCity}</h5>
                                                </div>
                                                <div onClick={onShowAdditionalInfo} className="Logs-show-style">Additional Info
                                                    <span className="cursor hover-style" title="Hide / Show Logs"
                                                        style={{ paddingRight: "20px", float: "right" }}>
                                                        <FontAwesomeIcon icon={!DlvrAdditionalInfo ? faPlus : faMinus} />
                                                    </span>
                                                </div>
                                                {DlvrAdditionalInfo && (<div className='p-1'>
                                                    <table className='table'>
                                                        <tbody>
                                                            <tr>
                                                                <td className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Customer Name :</span></td>
                                                                <td>{SelectedDlvrs.DestCustomerName}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ width: "250px" }} className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Dest Address :</span></td>
                                                                <td style={{ width: "70%" }}>{`${SelectedDlvrs.DestAddress}, ${SelectedDlvrs.DestCity}, ${SelectedDlvrs.DestState}, 
                                                    ${SelectedDlvrs.DestCountry}, ${SelectedDlvrs.DestPinCode}`}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Phone Number :</span></td>
                                                                <td>{SelectedDlvrs.DestContact}</td>
                                                            </tr>
                                                            {SelectedDlvrs && SelectedDlvrs.DeliveryDate && (<tr>
                                                                <td className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Tent. Delivery Date :</span></td>
                                                                <td>{moment(SelectedDlvrs.DeliveryDate).local().format("DD/MM/YYYY")}</td>
                                                            </tr>)}
                                                            <tr>
                                                                <td className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Truck Number :</span></td>
                                                                <td>{SelectedDlvrs.TrackingLink === "" ? (<span>{SelectedDlvrs.TruckNumber}</span>) :
                                                                    (<><a target='_blank' rel="noopener noreferrer" href={SelectedDlvrs.TrackingLink}>
                                                                        {SelectedDlvrs.TruckNumber}
                                                                    </a>
                                                                        <span className='ml-4 mr-2'><FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon></span>
                                                                        <span>Track your shipment here...</span></>)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Driver Contact :</span></td>
                                                                <td>{SelectedDlvrs.DriverContact}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>)}
                                            </div>
                                            {(SelectedDlvrs && SelectedDlvrs.DeliveryLogs &&
                                                SelectedDlvrs.DeliveryLogs.length > 0) && (<div style={{ marginBottom: "20px" }}>
                                                    <div onClick={onShowLogs} className="Logs-show-style">Logs
                                                        <span className="cursor hover-style" title="Hide / Show Logs" style={{ paddingRight: "20px", float: "right" }}><FontAwesomeIcon icon={!ShowLogs ? faPlus : faMinus} /></span></div>
                                                    {ShowLogs && (<div className="m-3" style={{ overflow: "auto" }}>
                                                        <table className="table table-striped table-bordered align-center">
                                                            <thead>
                                                                <tr>
                                                                    <th>SI No.</th>
                                                                    <th>Amount</th>
                                                                    <th style={{ width: "40%" }}>Remarks</th>
                                                                    <th>Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {SelectedDlvrs.DeliveryLogs.map((logs, index) => (
                                                                    <tr className="border-bottom" key={logs + "_" + index}>
                                                                        <td>
                                                                            <div style={{ padding: "0 20px" }} className="align-center">{index + 1}</div>
                                                                        </td>
                                                                        <td>
                                                                            <div>{logs.Amount}</div>
                                                                        </td>
                                                                        <td style={{ display: "flex", justifyContent: "center" }}>
                                                                            <div title={logs.Remarks} style={{
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis", whiteSpace: "nowrap", width: "250px"
                                                                            }}>{logs.Remarks}</div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="align-center">{moment(logs.CreatedDate).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>)}
                                                </div>)}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>)}
                </div>
            </div>
            <div id="SelectedSurvey" className="modal" style={{ display: displaySurveyView }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Survey View</span>
                        <span className="close" onClick={hideSurveyView}>&times;</span>
                    </div>

                    <table className="table tableTDWidthStyle">
                        <tbody>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedSurvey.Name || ""}
                                            type="text"></input>
                                        <span>Customer Name</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedSurvey.CompanyName ? (SelectedSurvey.CompanyName === "" ? "-" : SelectedSurvey.CompanyName) : "-"}
                                            type="text"></input>
                                        <span>Company Name</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <textarea style={{ resize: "none" }} rows="2" readOnly={true} placeholder="" value={SelectedSurvey.OriginAddress + ", " +
                                            SelectedSurvey.OriginCity + ", " + SelectedSurvey.OriginState + ", " +
                                            SelectedSurvey.OriginCountry + ", " + SelectedSurvey.OriginPincode}
                                            type="text"></textarea>
                                        <span>Origin Address</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <textarea style={{ resize: "none" }} rows="2" readOnly={true} placeholder="" value={SelectedSurvey.DestinationAddress + ", " +
                                            SelectedSurvey.DestinationCity + ", " + SelectedSurvey.DestinationState + ", " +
                                            SelectedSurvey.DestinationCountry + ", " + SelectedSurvey.DestinationPincode}
                                            type="text"></textarea>
                                        <span>Dest. Address</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedSurvey.OriginFloor || ""}
                                            type="text"></input>
                                        <span>Origin Floor</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedSurvey.DesinationFloor || ""}
                                            type="text"></input>
                                        <span>Dest. Floor</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedSurvey.PreferredPackingDate ? moment(SelectedSurvey.PreferredPackingDate).local().format("DD/MM/YYYY") : ""}
                                            type="text"></input>
                                        <span>Packing Date</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedSurvey.PreferredMovingDate ? moment(SelectedSurvey.PreferredMovingDate).local().format("DD/MM/YYYY") : ""}
                                            type="text"></input>
                                        <span>Moving Date</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedSurvey.PreferredDeliveryDate ? moment(SelectedSurvey.PreferredDeliveryDate).local().format("DD/MM/YYYY") : ""}
                                            type="text"></input>
                                        <span>Delivery Date</span>
                                    </div>
                                </td>
                                <td colSpan="2">
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedSurvey.IsInsured ? (SelectedSurvey.IsInsured === 1 ? SelectedSurvey.InsuranceAmount : "-") : "-"}
                                            type="text"></input>
                                        <span>Insurance Amount</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={(SelectedSurvey.IBAApproval && SelectedSurvey.IBAApproval === 0) ? "Yes" : "No"}
                                            type="text"></input>
                                        <span>IBA Approved</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedSurvey.IsGSTAvailable === 1 ? SelectedSurvey.GSTNumber : "-"}
                                            type="text"></input>
                                        <span>GST</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: "right" }} colSpan="2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="button" className="btn btn-default" onClick={hideSurveyView}>Close</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div id="SelectedSurvey" className="modal" style={{ display: displayGoodsView }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Goods View</span>
                        <span className="close" onClick={hideGoodsView}>&times;</span>
                    </div>
                    <div style={{ height: "60vh", overflow: "auto", overflowX: "hidden" }}>
                        <table className="table table-striped align-center">
                            <thead>
                                <tr>
                                    <th style={{ backgroundColor: "white", zIndex: "0" }}>Name</th>
                                    <th style={{ backgroundColor: "white", zIndex: "0" }}>Remarks</th>
                                    <th style={{ backgroundColor: "white", zIndex: "0" }}>Quantity</th>
                                    <th style={{ backgroundColor: "white", zIndex: "0" }}>CFT</th>
                                    <th style={{ backgroundColor: "white", zIndex: "0" }}>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {SelectedGoods.map((survey, index) => (
                                    <tr key={index}>
                                        <td>{survey.Name}</td>
                                        <td style={{ width: "300px", wordBreak: "break-word" }}>{survey.Remarks}</td>
                                        <td>{survey.Quantity}</td>
                                        <td>{survey.CFTValue}</td>
                                        <td>{parseInt(survey.Quantity) * parseInt(survey.CFTValue)}</td>
                                    </tr>
                                ))}
                                <tr style={{ fontSize: "1.3rem" }}>
                                    <td colSpan="4">Total CFT / Vehicle Load</td>
                                    <td>{TotalCFT} / {VehicleRequired}</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right" }} colSpan="5">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" className="btn btn-default" onClick={hideGoodsView}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default AdminDashBoard;